//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQInput from "@/components/Generics/AQInput/AQInput.vue";

export default {
    components: {
        AQInput
    },
    data() {
        return {
            date: "",
            time: "",
            datetime: ""
        };
    }
};
